import { render, staticRenderFns } from "./PermissionsDeleteModal.vue?vue&type=template&id=5883787e&"
import script from "./PermissionsDeleteModal.vue?vue&type=script&lang=js&"
export * from "./PermissionsDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports